import request from './request/default';
import { buildFormData } from '@/utils';

export function getCarDocDetail(reportNo, docSerNo) {
  return request
    .get(
      `/wireless/mobile/api/v1/car/reports/${reportNo}/docs/${docSerNo}/detail`,
    )
    .then(res => res.data);
}

export function uploadCarDocImage(reportNo, docSerNo, formUpload) {
  const formData = buildFormData(formUpload);
  return request
    .post(
      `/wireless/mobile/api/v1/car/reports/${reportNo}/docs/${docSerNo}/upload`,
      formData,
    )
    .then(res => res.data);
}

export function submitCarDocImage(reportNo, docSerNo) {
  return request
    .post(
      `/wireless/mobile/api/v1/car/reports/${reportNo}/docs/${docSerNo}/submit`,
    )
    .then(res => res.data);
}

export function eproposalShift(businessNo) {
  const params = { businessNo };
  return request
    .get('/uxcb/api/v1/eproposal/shift', { params })
    .then(res => res.data);
}
export function authShift(businessNo) {
  const params = { businessNo };
  return request
    .get('/uxcb/api/v1/eproposal/shift4Truck', { params })
    .then(res => res.data);
}

export function authConfig(businessNo, mobile) {
  const params = { businessNo, mobile };
  return request
    .get('/uxcb/api/v1/eproposal/authConfig', { params })
    .then(res => res.data);
}

export function sendPhoneMessage(businessNo, mobile) {
  const params = { businessNo, mobile };
  return request
    .get('/uxcb/api/v1/eproposal/sendPhoneMessage', { params })
    .then(res => res.data);
}

export function checkMessageCode(businessNo, mobile, verificationCode) {
  const params = { businessNo, mobile, verificationCode };
  return request
    .post('/uxcb/api/v1/eproposal/checkMessageCode', params)
    .then(res => res.data);
}

export function sendIdentityVCode(businessNo, mobile) {
  const params = { businessNo, mobile };
  return request
    .post('/uxcb/api/v1/eproposal/identityCollect/sendVCode', params)
    .then(res => res.data);
}

export function confirmIdentityVCode(businessNo, mobile, verificationCode) {
  const params = { businessNo, mobile, verificationCode };
  return request
    .post('/uxcb/api/v1/eproposal/identityCollect/confirmVCode', params)
    .then(res => res.data);
}

export function loadPayInfo(params) {
  return request
    .post(`/uxcb/api/v1/wireless/pay/loadPayInfo`, params)
    .then(res => res.data);
}
// 新中台支付申请接口
export function payApply(params) {
  return request
    .post(`/uxcb/api/v1/wireless/pay/payApply`, params)
    .then(res => res.data);
}

export function payOrderQuery(params) {
  return request
    .post(`/uxcb/api/v1/wireless/pay/payOrderQuery`, params)
    .then(res => res.data);
}

export function traceable(businessNo, serialNo) {
  const params = { businessNo, serialNo };
  return request
    .post('/uxcb/api/v1/eproposal/traceable', params)
    .then(res => res.data);
}
